import LabResult from '../../model/labResult'
import mapUser from './userMapper'
import moment from 'moment';

const positiveIndicator = "Positive";
const negativeIndicator = "Negative";
const pendingIndicator = "Result Pending";
const noResultIndicator = "No Result Available";
const equivocalIndicator = "Please Call";
const cancelledIndicator = "Result Cancelled";
const invalidIndicator = "Result Invalid";

export const POSITIVE = "positive";
export const NEGATIVE = "negative";
export const PENDING = "pending";
export const NORESULT = "noresult";
export const UNKNOWN = "unknown";
export const EQUIVOCAL = "equivocal";
export const CANCELLED = "cancelled";
export const INVALID = "invalid";

export function mapLabResults(data) {
    let results = [];
    let user = null;
    let newResult = null;

    user = mapUser(data);
    let id = 0;
    data.results.forEach((d) => {
        // Map coordinates
        let res = mapResult(d.result);
        let collectionDate = moment(d.collectionDate, moment.ISO_8601);
        let resultDate = moment(d.resultDate, moment.ISO_8601);
        console.log(collectionDate, resultDate);
        newResult = new LabResult(d.resultType, res, d.result, d.resultStatus, d.mnemonic, collectionDate, resultDate, d.collectionSite, d.resultId, d.labName, d.labAddressStreet, d.labAddressCity, d.labAddressProv, d.labAddressPostalCode, d.labAddressCountry);
        results.push(newResult);
        id += 1;
    });

    // If results are empty, we must have empty array
    // Map this to noresults
    if (results.length < 1) {
        let res = mapResult(noResultIndicator);
        let date = moment("1970-01-01", moment.ISO_8601);
        newResult = new LabResult(null, res, noResultIndicator, null, null, date);
        results.push(newResult);
    }

    // Sort results by date..
    let sortedResults = results.sort(function (a, b) {
        return b.resultDate - a.resultDate;
    });
    return { user, sortedResults };
}

function mapResult(result) {
    let res = NORESULT;
    if (result === positiveIndicator) {
        res = POSITIVE;
    } else if (result === negativeIndicator) {
        res = NEGATIVE;
    } else if (result === pendingIndicator) {
        res = PENDING;
    } else if (result === equivocalIndicator) {
        res = EQUIVOCAL;
    } else if (result === cancelledIndicator) {
        res = CANCELLED;
    } else if (result === invalidIndicator) {
        res = INVALID;
    }
    return res;
}
